import { TRootState } from "Redux/Reducers";

export const getAppUser = (id: string) => (state: TRootState) => state.appUser.entries[id];
